<template>
  <div>
    <img
      src="../assets/images/siteImages/404NotFound.svg"
      class="img-fluid mx-auto d-block my-5"
      width="500"
    />
  </div>
  <div class="text-center my-4">
    <h3 class="text-danger-gradient d-block">
      صفحه یا بخش مورد نظر وجود ندارد
    </h3>
    <!-- <button class="btn btn-primary" @click="backPage">
      <i class="fi fi-arrow-right"></i>بازگشت به صفحه قبل
    </button> -->
    <a class="btn btn-sm rounded btn-blueSite" href="/">
      <i class="fi fi-home"></i>
      صفحه اصلی
    </a>

    <!-- <a href="/" class="mx-auto d-block">بازگشت به خانه ...</a> -->
  </div>
</template>
<script>
export default {
  components: {},
  methods: {
    backPage() {
      window.history.back();
    },
  },
  mounted() {
    let spiners = document.getElementsByClassName('modal-backdrop fade show');
    if (spiners)
      while (spiners.length != 0) {
        spiners[0].remove();
      }
  },
};
</script>
